import React, { useState } from "react";

import TooltipComponent, { TooltipComponentProps } from "@/main/components/shared/tooltip/tooltipComponent";

import { isPartOriginInfoTarget } from "./partOriginInfo";

export default function PartOriginAwareTooltip({ children, ...props }: TooltipComponentProps) {
	const [isOpen, setIsOpen] = useState(false);

	function handleOpen(event: React.SyntheticEvent) {
		if (isPartOriginInfoTarget(event.target)) return;
		setIsOpen(true);
	}

	function handleMouseOver(event: React.MouseEvent) {
		if (isPartOriginInfoTarget(event.target)) setIsOpen(false);
		children.props.onMouseOver?.(event);
	}

	return (
		<TooltipComponent {...props} open={isOpen} onOpen={handleOpen} onClose={() => setIsOpen(false)}>
			{React.cloneElement(children, { onMouseOver: handleMouseOver })}
		</TooltipComponent>
	);
}
